/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetZReport200ResponseStats
 */
export interface GetZReport200ResponseStats {
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseStats
     */
    totalTabs: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseStats
     */
    openTabs: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseStats
     */
    totalSeats: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseStats
     */
    averageSeats: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseStats
     */
    averagePerTab: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseStats
     */
    averagePerSeat: number;
}

/**
 * Check if a given object implements the GetZReport200ResponseStats interface.
 */
export function instanceOfGetZReport200ResponseStats(value: object): value is GetZReport200ResponseStats {
    if (!('totalTabs' in value) || value['totalTabs'] === undefined) return false;
    if (!('openTabs' in value) || value['openTabs'] === undefined) return false;
    if (!('totalSeats' in value) || value['totalSeats'] === undefined) return false;
    if (!('averageSeats' in value) || value['averageSeats'] === undefined) return false;
    if (!('averagePerTab' in value) || value['averagePerTab'] === undefined) return false;
    if (!('averagePerSeat' in value) || value['averagePerSeat'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseStatsFromJSON(json: any): GetZReport200ResponseStats {
    return GetZReport200ResponseStatsFromJSONTyped(json, false);
}

export function GetZReport200ResponseStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200ResponseStats {
    if (json == null) {
        return json;
    }
    return {
        
        'totalTabs': json['totalTabs'],
        'openTabs': json['openTabs'],
        'totalSeats': json['totalSeats'],
        'averageSeats': json['averageSeats'],
        'averagePerTab': json['averagePerTab'],
        'averagePerSeat': json['averagePerSeat'],
    };
}

export function GetZReport200ResponseStatsToJSON(json: any): GetZReport200ResponseStats {
    return GetZReport200ResponseStatsToJSONTyped(json, false);
}

export function GetZReport200ResponseStatsToJSONTyped(value?: GetZReport200ResponseStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalTabs': value['totalTabs'],
        'openTabs': value['openTabs'],
        'totalSeats': value['totalSeats'],
        'averageSeats': value['averageSeats'],
        'averagePerTab': value['averagePerTab'],
        'averagePerSeat': value['averagePerSeat'],
    };
}

